// Who we are and where. The server's BUSINESS_ADDRESS / BUSINESS_NAME settings are the source (GET /api/business-info); this default is the registered
// business address, used in the static legal text (Terms, Privacy) and while the server answer is loading or unavailable.
import { useEffect, useState } from 'react';

export const BUSINESS_DEFAULT = {
  name: 'Pindi Inc. d/b/a RideBuraq',        // the LEGAL name: only Terms, Privacy, receipts and the SMS consent wording use it
  brand: 'RideBuraq',                           // the only name customers see everywhere else
  addressLines: ['535 Fifth Avenue, 4th Floor #1075', 'New York, NY 10017'],
  address: '535 Fifth Avenue, 4th Floor #1075, New York, NY 10017',
  supportEmail: 'support@rideburaq.com',
};

export const mergeBusiness = (answer) => {
  if (!answer || typeof answer !== 'object') return BUSINESS_DEFAULT;
  // a line with no digit in it (a person's name) is not part of an address and is never shown
  const lines = Array.isArray(answer.addressLines) ? answer.addressLines.filter((x) => typeof x === 'string' && /\d/.test(x)).map((x) => x.trim()) : [];
  return {
    name: (typeof answer.name === 'string' && answer.name.trim()) || BUSINESS_DEFAULT.name,
    brand: BUSINESS_DEFAULT.brand,
    addressLines: lines.length ? lines : BUSINESS_DEFAULT.addressLines,
    address: lines.length ? lines.join(', ') : BUSINESS_DEFAULT.address,
    supportEmail: (typeof answer.supportEmail === 'string' && answer.supportEmail) || BUSINESS_DEFAULT.supportEmail,
  };
};

export function useBusinessInfo() {
  const [info, setInfo] = useState(BUSINESS_DEFAULT);
  useEffect(() => {
    let alive = true;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/business-info`)
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (alive && j) setInfo(mergeBusiness(j)); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return info;
}
